import { ActivatedRoute, Router } from '@angular/router';
import { ColumnSetting } from './model/table-layout.model';
import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'environments/environment';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SwapButtonComponent } from '../table-action-buttons/swap-button/swap-button.component';
import { ViewImageButtonTableComponent } from '../table-action-buttons/view-image/view-image-button.component';
import { ViewButtonTableComponent } from '../table-action-buttons/view-button/view-button.component';
import { DeleteButtonTableComponent } from '../table-action-buttons/delete-button/delete-button.component';
import { ReadOnlyComponent } from '../table-action-buttons/read-only/read-only.component';
import { EditButtonTableComponent } from '../table-action-buttons/edit-button/edit-button.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgFor } from '@angular/common';
import { TooltipIfTruncatedDirective } from '../directives/tooltip-if-truncated.directive';


@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'table-layout',
    templateUrl: './table-layout.component.html',
    styleUrls: ['./table-layout.component.scss'],
    imports: [
        NgIf, MatTooltipModule, NgFor, ReactiveFormsModule, EditButtonTableComponent, ReadOnlyComponent,
        DeleteButtonTableComponent, ViewButtonTableComponent, ViewImageButtonTableComponent,
        SwapButtonComponent, MatPaginatorModule, TooltipIfTruncatedDirective
    ]
})
export class TableLayoutComponent implements OnInit, OnChanges {
  @Input() columnSettings: ColumnSetting[];
  @Input() filters: any[];
  @Input() hideButton = false;
  @Input() pageNumber: number;
  @Input() parent: string;
  @Input() perPage: number;
  @Input() records: any[];
  @Input() routeTitle: string;
  @Input() tableActions;
  @Input() totalRecords: number;
  @Input() pagination: boolean;
  @Input() addBtnText = 'Crear';
  /** flag for copy settings button */
  @Input() canCopy = false;
  /** flag for download CSV button */
  @Input() isDownloadable = false;
  /** flag for import CSV button */
  @Input() canImportCsv = false;

  @Input() uploadDocumentText = 'Importar';
  /** flag for upload files button */
  @Input() fileXlsxButton = false;

  @Output() deleteEntity = new EventEmitter();
  @Output() changePage = new EventEmitter();
  @Output() filesReady = new EventEmitter();
  /** event fired on download CSV */
  @Output() downloadCSV = new EventEmitter();
  /** event fired on upload CSV*/
  @Output() sendFile = new EventEmitter();
  /** event fired on copy settings */
  @Output() copySettings = new EventEmitter();
  @Output() changeOrder = new EventEmitter();
  @Output() openImage = new EventEmitter();

  columnMaps: ColumnSetting[];
  deleteAction = true;
  editAction = true;
  editTaskAction = true;
  keys: string[];
  totalColumns: number;
  viewAction = true;
  viewTaskAction = true;
  swapAction = false;
  /** the image button used to show up for any record carrying a photo, action or not */
  viewImageAction = false;
  readOnlyAction: any;
  isUploading = false;
  baseUrl: string;

  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router
    ) {
      this.pagination = true;
      this.baseUrl = environment.file;
    }




    ngOnInit() {
      this.routeTitle = this.route.snapshot.data['title'];
      this.parent = this.route.snapshot.data['parent'];

      this.totalColumns = this.columnSettings.length;
      if (this.tableActions) { this.totalColumns++; }

    }

    ngOnChanges() {
      if (this.columnSettings) {
        this.columnMaps = this.columnSettings;
      } else {
        this.columnMaps = Object.keys(this.records[0])
        .map(key => {
          return {
            primaryKey: key,
            header: key.slice(0, 1).toUpperCase() +
            key.replace(/_/g, ' ').slice(1)
          };
        });
      }
      this.validateActions();
    }

    validateActions() {
      if (this.tableActions) {
        this.editAction = this.tableActions.find(elem => elem === 'edit');
        this.editTaskAction = this.tableActions.find(elem => elem === 'editTask');
        this.viewAction = this.tableActions.find(elem => elem === 'view');
        this.viewTaskAction = this.tableActions.find(elem => elem === 'viewTask');
        this.deleteAction = this.tableActions.find(elem => elem === 'delete');
        this.readOnlyAction = this.tableActions.find(elem => elem === 'readOnly');
        this.swapAction = this.tableActions.find(elem => elem === 'swap');
        this.viewImageAction = this.tableActions.find(elem => elem === 'viewImage');
      }
    }

    trackByFn(record) {
      return record.id;
    }

    onChangePage(event) {
      this.changePage.emit(event.pageIndex + 1);
    }

    addRoute() {
      this.router.navigate([this.parent + '/add']);
    }

    goToEdit(id) {
      this.router.navigate([this.parent + '/edit/', id]);
    }

    goToEditTask(id) {
      const url = this.parent + '/edit/' + id;
      window.open(url, '_blank');
    }

    goToReadOnly(id) {
      this.router.navigate([this.parent + '/read-only/', id]);
    }

    goToViewTask(id) {
      const url = this.parent + '/read-only/' + id;
      window.open(url, '_blank');
    }

    goToView(id) {
      this.router.navigate(['/vista-plan', id]);
    }

    /**
     * Every photo of a record, browser-resolvable: the `images` collection when the model has one,
     * and the single `imageUrl` otherwise.
     */
    imagesOf(record): string[] {
      const images = record.images && record.images.length ? record.images : [record.imageUrl];
      return images
        .map(image => image && (image.url || image))
        .filter(url => !!url)
        .map(url => url.startsWith('http') ? url : this.baseUrl + url);
    }

    viewImage(images: string[]) {
        this.openImage.emit(images);
    }

    delete(id) {
      this.deleteEntity.emit(id);
    }

  onDownload(): void {
    this.downloadCSV.emit();
  }

  onSendCsvFile(file: File): void {
    this.sendFile.emit(file);
  }

  onCopySettings(): void {
    this.copySettings.emit();
  }

  uploadDocument(event: any) {
    if (event.target.files.length > 0) {
      this.isUploading = true;
      const file = event.target.files[0];
      this.filesReady.emit(file);
      this.fileInput.nativeElement.value = '';
      this.isUploading = false;
    }
  }

}
